import React from 'react';
import { StatusProps } from './type';

import {
	getStatusColor,
	getRhStatusText,
	getDoctorStatusText,
} from './formatter';
import { Container, Circle, Text } from './Status.styles';

export const Status = ({ nameRh, nameDoctor }: StatusProps): JSX.Element => {
	const stringStatus = nameRh
		? getRhStatusText(nameRh)
		: getDoctorStatusText(nameDoctor);

	return (
		<Container>
			<Circle backgroundColor={getStatusColor(nameRh || nameDoctor)} />
			<Text>{stringStatus}</Text>
		</Container>
	);
};
